import i18next from 'i18next';
import VueI18 from '@panter/vue-i18next';

const VueI18Next = VueI18 || window.VueI18Next;
let vueI18n;

/**
 * Exposes i18next's translation capabilities to non-Vue code
 * @param key
 * @param val
 * @returns {string}
 */
export function translate (key, options) {
  if (!I18nService.isInitialized) {
    throw new Error('i18n is not initialized');
  }
  const defaultOptions = {ns: 'webviewer'};
  options = Object.assign(defaultOptions, options);

  return i18next.t(key, options);
}

/**
 * Generates a helper function that auto-prefixes all `translate` requests
 * usage:
 *     // Assume i18n contains: { some: { key: { prefix: { 'my-value': 'toasty' } } } }
 *     import {translate} from 'shared/services/I18nService';
 *     const $t = translate.scope('some.key.prefix');
 *     const someText = $t('my-value'); // -> 'toasty'
 */
translate.scope = function (keyPrefix) {
  return (key, options) => translate(`${keyPrefix}.${key}`, options);
};

/**
 * Exposes vue-i18next to Vue code
 * @returns {vueI18n} initialized instance of VueI18Next
 */
export function getVueI18n () {
  if (!vueI18n) {
    throw new Error('i18n is not initialized');
  }
  return vueI18n;
}

export class I18nService {
  /**
   * This service simply installs the i18n and vue-i18n as a read-only property on the Vue prototype., which will then
   * be accessible to all components through the service locator.
   * @param Vue
   * @param lang
   */
  static isInitialized = false;

  static async install (Vue) {
    Vue.use(VueI18Next);

    vueI18n = new VueI18Next(i18next);
  }

  static async init () {
    if (i18next.isInitialized) {
      I18nService.isInitialized = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/I18nService.js